import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yinhangka",
  "use": "icon-yinhangka-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-yinhangka\"><defs><style type=\"text/css\"></style></defs><path d=\"M960 128v768H64V128h896z m-92.608 322.816H156.544l0.064 354.688h710.784V450.816zM484.032 618.88v90.496H230.144V618.88h254.016z m383.36-400.384H156.608V360.32h710.784V218.496z\" p-id=\"9504\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol